export default "__VITE_ASSET__DMo5IaYt__"